import { useState, useCallback, useEffect } from 'react';

export interface queueProps<T> {
  isProcessing: boolean;
  tasks: Promise<T>[];
}

function useTaskQueue<T>(shouldProcess: boolean) {
  const [queue, setQueue] = useState<queueProps<T>>({
    isProcessing: false,
    tasks: [],
  });

  useEffect(() => {
    if (!shouldProcess) return;
    if (queue.tasks.length === 0) return;
    if (queue.isProcessing) return;

    const task: any = queue.tasks[0];

    setQueue((prev) => ({
      isProcessing: true,
      tasks: prev.tasks.slice(1),
    }));

    Promise.resolve(task()).finally(() => {
      setQueue((prev) => ({
        isProcessing: false,
        tasks: prev.tasks,
      }));
    });
  }, [queue, shouldProcess]);

  return {
    tasks: queue.tasks,
    isProcessing: queue.isProcessing,
    addTask: useCallback((task: any) => {
      setQueue((prev) => ({
        isProcessing: prev.isProcessing,
        tasks: [...prev.tasks, task],
      }));
    }, []),
  };
}

export default useTaskQueue;
